"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _1 = require(".");
const routingStackGetUniqueKey = (stack) => (0, _1.generateUniqueName)({
    name: 'r',
    names: stack.map((route) => route.key),
});
exports.default = routingStackGetUniqueKey;
